import { Label } from '@/shared/ui/primitives'
import { PhoneInput } from '@/shared/ui/primitives/phone-input'

type PhoneFieldProps = {
  id: string
  label: string
  value: string
  onChange: (e164: string) => void
  onBlur?: () => void
  error?: string
  required?: boolean
  disabled?: boolean
}

function PhoneField({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  required,
  disabled,
}: PhoneFieldProps) {
  return (
    <div className="grid gap-2">
      <Label htmlFor={id}>
        {label}
        {required ? ' *' : null}
      </Label>
      <PhoneInput
        id={id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
      />
      {error ? (
        <p id={`${id}-error`} className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  )
}

export { PhoneField }
export type { PhoneFieldProps }
